import React from "react";
import { Grid } from "semantic-ui-react";
import { PopupMessageContext } from "components/popup-message";
import { UsersReportContext } from "../context";
import { ReportsGenerator } from "./report-generator";
import { Panel } from "components/panel";

export const MPosUsersReportsView = ({ phoneView }) => {
  return (
    <Grid centered padded>
      <PopupMessageContext context={UsersReportContext} />
      <Grid.Column width={phoneView ? 16 : 10}>
        <Panel>
          <ReportsGenerator phoneView={phoneView} />
        </Panel>
      </Grid.Column>
    </Grid>
  );
};
